import { render, staticRenderFns } from "./DrawingBoardModal.vue?vue&type=template&id=4fccf87a&scoped=true&"
import script from "./DrawingBoardModal.vue?vue&type=script&lang=js&"
export * from "./DrawingBoardModal.vue?vue&type=script&lang=js&"
import style0 from "./DrawingBoardModal.vue?vue&type=style&index=0&id=4fccf87a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fccf87a",
  null
  
)

export default component.exports